import api from './api';
import type { SystemAlert } from '@/types/systemAlerts';

export const systemAlertsService = {
  async getActive(): Promise<SystemAlert[]> {
    const response: any = await api.get('/alerts/active');
    return response?.data || [];
  },

  async acknowledge(id: number): Promise<SystemAlert> {
    const response: any = await api.put(`/alerts/${id}/acknowledge`, {});
    return response?.data;
  },
};
